import React from "react";
import "./PageHeader.css";

/**
 * Unified page title section — icon, title, description, optional actions toolbar.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {React.ComponentType|React.ReactNode} [props.icon] — icon component or node
 * @param {React.ReactNode} [props.actions] — toolbar slot (filters, selects, buttons)
 * @param {string} [props.className]
 * @param {boolean} [props.flat] — no card chrome (e.g. inside padded dashboard shells)
 */
export default function PageHeader({
  title,
  description,
  icon: Icon,
  actions,
  className = "",
  flat = false,
}) {
  const rootClass = ["lt-page-header", flat && "lt-page-header--flat", className]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={rootClass}>
      {Icon ? (
        <div className="lt-page-header__icon" aria-hidden>
          {typeof Icon === "function" ? <Icon /> : Icon}
        </div>
      ) : null}
      <div className="lt-page-header__text">
        <h1 className="lt-page-header__title">{title}</h1>
        {description ? (
          <div className="lt-page-header__desc">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="lt-page-header__actions">{actions}</div> : null}
    </header>
  );
}

/** Label for toolbar controls inside PageHeader `actions`. */
export function PageHeaderActionsLabel({ className = "", ...props }) {
  return (
    <label
      className={`lt-page-header__actions-label ${className}`.trim()}
      {...props}
    />
  );
}

/** Styled control wrapper class for selects/inputs in PageHeader toolbar. */
export const pageHeaderActionsControlClass = "lt-page-header__actions-control";
